var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"flex":"","fdc":""}},[_c('div',{staticClass:"logo-box",attrs:{"flex":"","fjb":"","fic":""}},[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }